// 相机旋转
export const cameraRotateList = [
  'Right-top',
  'Right-bottom',
  'Left-top',
  'Left-bottom'
]

// 案例详情限制图片上传上限
export const CASE_CONTENT_IMAGE_LIMIT = 50
// 客照图片上传上限
export const UNINO_PHOTO_LIMIT = 20
